// E-Ticaret › Slider Ayarları kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'ecommerce.slider';

export const ecommerceSliderGuide = (t: TFunction): GuideContent => ({
  layout: 'stacked',
  title: t(`${G}.title`, 'Slider nasıl hazırlanır?'),
  intro: t(`${G}.intro`, 'Ana sayfanın en üstünde dönen büyük görselleri (slider) burada hazırlarsınız: görseller, mobil görseller, görsel üzerindeki yazı ve butonlar. Bu ekrandaki ayarlar siz değiştirdikçe kendiliğinden kaydedilir. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Slider Ayarları'),
    form: t(`${G}.regions.form`, 'Genel ayarlar ve görsel ekleme'),
    list: t(`${G}.regions.list`, 'Yüklenmiş Görseller'),
    footer: t(`${G}.regions.footer`, 'Slider Üzerine Yazı'),
  },
  steps: [
    {
      region: 'form',
      title: t(`${G}.s1.title`, '1. Genel ayarlar'),
      text: t(`${G}.s1.text`, '"Slider Aktif" slider\'ı sitede açar / kapatır. "Otomatik Oynat" açıkken görseller kendiliğinden geçer; "Süre" her resmin ekranda kalma süresidir (videolar kendi süreleri boyunca oynatılır). "Web Yüksekliği" ve "Mobil Yüksekliği" ekran yüksekliğinin yüzdesi (vh) olarak ayrı ayrı ayarlanır; örneğin 60vh ekranın %60\'ıdır.'),
      tips: [
        t(`${G}.s1.tip1`, '"Alttan karartma" görselin altından yukarı doğru koyu bir geçiş ekler (yazıyı okunur yapar); "Görsel bulanıklığı" tüm slider görsellerine ortak bulanıklık uygular. İkisinin de yoğunluğu ayarlanabilir.'),
      ],
    },
    {
      region: 'form',
      title: t(`${G}.s2.title`, '2. Slayt ekleyin'),
      text: t(`${G}.s2.text`, '"Slider Görselleri Yönet" resim kütüphanesini açar; seçtiğiniz görseller ve videolar sırayla slider\'a eklenir ve "Yüklenmiş Görseller" bölümünde kart olarak görünür. Bir slaytı kaldırmak için kartındaki silme düğmesini kullanın; onay sorulur.'),
      tips: [
        t(`${G}.s2.tip1`, 'Yeni eklenen slayt listenin sonuna eklenir; slaytlar eklenme sırasıyla gösterilir.'),
      ],
    },
    {
      region: 'list',
      title: t(`${G}.s3.title`, '3. Mobil resim'),
      text: t(`${G}.s3.text`, 'Her slider görseli için kartındaki "Mobil Resim Ekle" ile ayrı bir mobil resim yükleyebilirsiniz. Mobil resim yüklenmezse ana resim hem masaüstünde hem mobilde kullanılır.'),
      tips: [
        t(`${G}.s3.tip1`, 'Mobil resimler genellikle dikey (9:16) veya kare (1:1) formatında daha iyi görünür.'),
      ],
    },
    {
      region: 'footer',
      title: t(`${G}.s4.title`, '4. Görsel üzerindeki yazı'),
      text: t(`${G}.s4.text`, '"Slider Üzerine Yazı" bölümünde yazının nasıl uygulanacağını seçin: "Tek resme uygula" (yazı yalnız seçtiğiniz slaytta görünür), "Her resme ayrı" (her slaytın kendi yazısı olur, geçişte değişir) veya "Yazı sabit, görseller kayar" (yazı ortada sabit kalır, arkada resimler döner). Başlık ve açıklamanın metnini, rengini, yazı tipini, boyutunu, konumunu, hizasını ve giriş animasyonunu buradan ayarlayın.'),
      tips: [
        t(`${G}.s4.tip1`, '"Her resme ayrı" modunda bir slayta özel yazı için slayt kartındaki dişli simgesini (Slayt yazı ayarları) kullanın; buradaki metin varsayılan olarak kullanılır.'),
        t(`${G}.s4.tip2`, 'Başlıkta her satır Enter ile ayrılır. Bir kelimeyi farklı renkte göstermek için "İki renkli başlık" seçeneğini kullanın veya başlıkta kelimeyi çift köşeli parantez içine yazın.'),
      ],
    },
    {
      region: 'list',
      title: t(`${G}.s5.title`, '5. Buton aksiyonu'),
      text: t(`${G}.s5.text`, 'Slayt kartındaki "Buton ekle" düğmesiyle slayta en fazla 4 buton ekleyebilirsiniz. Her buton için metin, stil, boyut, renk ve yer seçilir. "Aksiyon" butonun ne yapacağını belirler: Bölüme kaydır (sayfadaki bir bölüme kayar), URL / sayfa (hazır veya özel bir sayfaya gider), İletişim sayfası, Ürünler sayfası veya Forma yönlendir (seçilen form aynı sayfada yan panelde açılır).'),
      tips: [
        t(`${G}.s5.tip1`, 'Butonun yazının hemen altında durmasını istiyorsanız "Buton yeri" olarak "Metinle birlikte" seçin; diğer seçenekler butonu yazıdan ayrı bir köşeye taşır.'),
      ],
    },
    {
      region: 'form',
      title: t(`${G}.s6.title`, '6. Arka plan'),
      text: t(`${G}.s6.text`, 'Henüz hiç slayt yokken "Slider Arka Planı" bölümü görünür: slider alanının arka planını "Düz Renk" ya da "Doğrusal Geçiş" (renkler ve geçiş yönü) olarak ayarlayıp önizlemesine bakabilirsiniz.'),
      tips: [
        t(`${G}.s6.tip1`, 'Başlıktaki (i) düğmesi bu rehberi her zaman yeniden açar.'),
      ],
    },
  ],
});
